<template>
  <div>
    <v-container fluid class="mt-5">
      <v-row>
        <v-data-iterator
            :items="itemList"
            item-key="id"
            :items-per-page="10"
            hide-default-footer
            sort-by="batch_size"
            no-data-text=""
        >
          <template v-slot:default="{ items, isExpanded, expand }">
            <v-chip
                v-for="item in items"
                :key="item.batch_size"
                class="chip"
            >
              {{ item.batch_size }}
              <v-spacer></v-spacer>
              <v-icon @click="onDeleteItem(item)" class="ml-5">
                mdi-close-circle
              </v-icon>
            </v-chip>
          </template>
        </v-data-iterator>
        <v-text-field
            dense
            outlined
            rounded
            label="Batch size"
            :loading="loading"
            type="number"
            class="batch-size"
            v-model="newBatchSize"
        >
          <template v-slot:append-outer>
            <span v-if="newBatchSize > 0 && !getBatchSizeNumberList.includes(newBatchSize)">
              <v-icon @click="onAddBatchSize" class="mr-n5">mdi-plus-circle</v-icon>
            </span>
          </template>
        </v-text-field>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'MPNResearchBatchV2',
  params: ['itemId'],

  computed: {
    ...mapGetters('MPNResearchBatch', ['getBatchSizeNumberList']),
    ...mapFields('MPNResearchBatch', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive',
      'filters']),
  },

  methods: {
    ...mapActions('MPNResearchBatch', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField']),
    onDeleteItem(item) {
      this.selectedItemList = [item]
      this.fetchDeleteSelectedItem()
    },
    onAddBatchSize() {
      this.fetchSaveItemField({
        itemId: null,
        fields_dict: {
          mpn_research: this.$route.params.itemId,
          batch_size: this.newBatchSize,
        },
      })
      this.newBatchSize = null
    }
  },

  mounted() {
    this.filters = {mpn_research_id: this.$route.params.itemId}
    this.fetchItemList()
  },

  data() {
    return {
      newBatchSize: null,
    }
  },
}

</script>


<style scoped lang="scss">
.batch-size {
  max-width: 200px;
}

.v-chip.v-size--default {
  height: 38px;
}
</style>